import { HOWITWORKS } from "@/constants/testIds/site";
import { Search, SprayCan, ShieldCheck, CalendarCheck } from "lucide-react";

const steps = [
  {
    id: HOWITWORKS.step1,
    icon: CalendarCheck,
    label: "01 · Book",
    title: "Pick a date",
    text: "Choose any available day on the calendar. We'll confirm by phone or email within hours.",
  },
  {
    id: HOWITWORKS.step2,
    icon: Search,
    label: "02 · Survey",
    title: "On‑site survey",
    text: "We assess the glass, check for damage, and prepare the surface meticulously.",
  },
  {
    id: HOWITWORKS.step3,
    icon: SprayCan,
    label: "03 · Apply",
    title: "ClearShield bonds",
    text: "A precise application of Ritec's ClearShield, cured on the spot. No mess. No fuss.",
  },
  {
    id: HOWITWORKS.step4,
    icon: ShieldCheck,
    label: "04 · Protect",
    title: "10 years of clarity",
    text: "Your glass is now hydrophobic — easier to clean, harder to stain, brilliantly clear.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid={HOWITWORKS.section}
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-emerald-700">
            How ClearShield works
          </div>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tight">
            Four steps. One <span className="italic font-semibold">remarkable</span> result.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={s.id}
                className="relative rounded-3xl bg-white border border-slate-200 p-7 hover-lift overflow-hidden"
              >
                <div className="absolute -top-4 -right-4 font-display text-[140px] font-bold leading-none text-emerald-50 select-none">
                  {i + 1}
                </div>
                <div className="relative">
                  <div className="w-12 h-12 rounded-2xl bg-emerald-100 flex items-center justify-center">
                    <Icon size={22} className="text-emerald-700" />
                  </div>
                  <div className="mt-5 text-[10px] font-bold tracking-widest uppercase text-slate-500">
                    {s.label}
                  </div>
                  <div className="mt-2 font-display text-2xl font-semibold text-emerald-950">
                    {s.title}
                  </div>
                  <div className="mt-3 text-slate-600 leading-relaxed text-sm">
                    {s.text}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
